var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMakeDough = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_2409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.85 16.3663C25.85 18.6493 24.1203 21.0065 21.381 22.8733C18.6788 24.7149 15.3101 25.85 12.6389 25.85C10.0837 25.85 8.55375 24.8188 7.59499 23.2296C6.58113 21.549 6.15 19.1397 6.15 16.3663C6.15 11.4692 10.2195 8.15 15.6667 8.15C21.2104 8.15 25.85 11.5473 25.85 16.3663Z",
    stroke: "#ED3D46",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.66625,
    y: 9.78247,
    width: 3.7,
    height: 22.7,
    transform: "rotate(-45 6.66625 9.78247)",
    fill: "white",
    stroke: "#ED3D46",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.03987,
    y: 6.56787,
    width: 1.45399,
    height: 3.05831,
    transform: "rotate(-45 5.03987 6.56787)",
    stroke: "#ED3D46",
    strokeWidth: 1.45399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5697,
    y: 25.0872,
    width: 1.43914,
    height: 3.3559,
    transform: "rotate(-45 23.5697 25.0872)",
    stroke: "#ED3D46",
    strokeWidth: 1.43914
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_2409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMakeDough);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MakeDough.82f7c2aad139a6c4e39fabeaad3537fb.svg";